import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { HandComponent } from './Poker.HandComponent';

@Injectable()
export class HandGuardGuard implements CanDeactivate<HandComponent> {
  canDeactivate(
    component: HandComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component.canDeactivate) {
      return true;
    }
    return confirm("Warning: Game in progress, exit anyway?");
  }
  
}
